import React, { useState } from 'react';
import AnchoredModal from '@components/Shared/Modal/AnchoredModal/AnchoredModal';
import DropDownList from '@components/Shared/DropDownList/DropDownList';
import RadioButtonGroup from 'pubweb-smokey/dist/components/RadioButton/RadioButtonGroup';
import { getVerticalOffsetForOverlay } from './getVerticalOffset';
import {
  allMaxSquareFeet,
  allMinSquareFeet,
  DEFAULT_MAX_SQ_FT,
  DEFAULT_MIN_SQ_FT,
  DEFAULT_SECTION,
} from '@utils/homeSearchConstants';
import { Section } from '@utils/homeSearchConstants';

type Props = {
  minSquareFeet: number;
  maxSquareFeet: number;
  section: Section;
  onCloseClick: () => void;
  onApplyClick: (updatedSize: {
    minSquareFeet: number;
    maxSquareFeet: number;
    section: Section;
  }) => void;
};

const FilterSize = ({
  minSquareFeet,
  maxSquareFeet,
  section = 'all',
  onCloseClick,
  onApplyClick,
}: Props) => {
  const sectionItems: { value: Section; text: string }[] = [
    { value: 'all', text: 'All' },
    { value: 'single', text: 'Single' },
    { value: 'multi', text: 'Multi' },
    { value: 'crossmod', text: 'CrossMod' },
  ];

  const [filterMinSquareFeet, setFilterMinSquareFeet] = useState(minSquareFeet);
  const [filterMaxSquareFeet, setFilterMaxSquareFeet] = useState(maxSquareFeet);
  const [filterSection, setFilterSection] = useState<Section>(section);

  const minSquareFeetItems = allMinSquareFeet.filter(
    (x) => x.value < filterMaxSquareFeet
  );
  const maxSquareFeetItems = allMaxSquareFeet.filter(
    (x) => x.value > filterMinSquareFeet
  );

  return (
    <AnchoredModal
      automationId="filters-size"
      applyButtonClassName="filters-size-apply-button"
      clearButtonClassName="filters-clear-button"
      onApplyButtonClick={() => {
        if (
          minSquareFeet === filterMinSquareFeet &&
          maxSquareFeet === filterMaxSquareFeet &&
          section === filterSection
        ) {
          onCloseClick();
        } else {
          onApplyClick({
            minSquareFeet: filterMinSquareFeet,
            maxSquareFeet: filterMaxSquareFeet,
            section: filterSection,
          });
        }
      }}
      onClearButtonClick={() => {
        if (
          minSquareFeet === DEFAULT_MIN_SQ_FT &&
          maxSquareFeet === DEFAULT_MIN_SQ_FT &&
          section === DEFAULT_SECTION
        ) {
          onCloseClick();
        } else {
          onApplyClick({
            minSquareFeet: DEFAULT_MIN_SQ_FT,
            maxSquareFeet: DEFAULT_MAX_SQ_FT,
            section: DEFAULT_SECTION,
          });
        }
      }}
      showOverflow={true}
      onCloseClick={onCloseClick}
      pageOverlayVerticalOffsetInPixels={getVerticalOffsetForOverlay()}
    >
      <div>
        <h6 className="pb-3">Square Feet</h6>
        <div className="grid grid-cols-[1fr_min-content_1fr] pb-5">
          <DropDownList
            automationId="filter-min-square-feet-click"
            id="min-square-feet-dropdown"
            dropDownStyle="compact"
            label={filterMinSquareFeet.toString()}
            onChange={({ value }: { value: number }) => {
              setFilterMinSquareFeet(value);
            }}
            items={minSquareFeetItems}
            selectedValue={filterMinSquareFeet}
            defaultValue={filterMinSquareFeet}
            disabled={undefined}
            errorMessage={undefined}
            ariaLabel={undefined}
            onTextChange={undefined}
            selectedItem={undefined}
            selectRef={undefined}
            textBoxRef={undefined}
          >
            <></>
          </DropDownList>
          <div className="grid place-content-center px-2">-</div>
          <DropDownList
            automationId="filter-max-square-feet-click"
            id="max-square-feet-dropdown"
            dropDownStyle="compact"
            label={filterMaxSquareFeet.toString()}
            onChange={({ value }: { value: number }) => {
              setFilterMaxSquareFeet(value);
            }}
            items={maxSquareFeetItems}
            selectedValue={filterMaxSquareFeet}
            defaultValue={filterMaxSquareFeet}
            disabled={undefined}
            errorMessage={undefined}
            ariaLabel={undefined}
            onTextChange={undefined}
            selectedItem={undefined}
            selectRef={undefined}
            textBoxRef={undefined}
          >
            <></>
          </DropDownList>
        </div>

        <div className="pb-3">
          <h6 className="pb-3">Sections</h6>
          <RadioButtonGroup
            id="section"
            items={sectionItems}
            defaultValue={filterSection}
            onChange={({ value }: { value: Section }) => {
              setFilterSection(value);
            }}
          />
        </div>
      </div>
    </AnchoredModal>
  );
};

export default FilterSize;
